export default "__VITE_ASSET__BPkOL9$r__"